import { render, staticRenderFns } from "./ChoicePracticeBase.vue?vue&type=template&id=1c07b2e9&scoped=true&"
import script from "./ChoicePracticeBase.vue?vue&type=script&lang=js&"
export * from "./ChoicePracticeBase.vue?vue&type=script&lang=js&"
import style0 from "./ChoicePracticeBase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChoicePracticeBase.vue?vue&type=style&index=1&id=1c07b2e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07b2e9",
  null
  
)

export default component.exports